import { Box, Stack, Skeleton, useTheme } from '@ltvco/refresh-lib/theme';

export const TeaserSkeleton = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        mt: 2,
        mb: 2,
        padding: theme.spacing(2),
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: theme.spacing(1),
      }}
    >
      <Stack spacing={2}>
        {/* Header skeleton */}
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Skeleton variant="rounded" height={28} width={150} />
          <Skeleton variant="rounded" height={32} width={32} />
        </Stack>

        {/* Cards grid skeleton */}
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: '1fr',
              sm: 'repeat(2, 1fr)',
              md: 'repeat(3, 1fr)',
            },
            gap: 1.5,
          }}
        >
          {[1, 2, 3].map((index) => (
            <Box
              key={index}
              sx={{
                padding: theme.spacing(1.5, 2),
                backgroundColor: theme.palette.background.paper,
                borderRadius: theme.spacing(0.5),
              }}
            >
              <Stack spacing={1.5} direction="row">
                {/* Icon skeleton */}
                <Skeleton
                  variant="circular"
                  width={40}
                  height={40}
                  sx={{ flexShrink: 0 }}
                />
                {/* Content skeleton */}
                <Stack spacing={0.5} sx={{ flex: 1, minWidth: 0 }}>
                  <Skeleton variant="text" width="80%" height={24} />
                  <Skeleton variant="text" width="100%" height={16} />
                  <Skeleton variant="text" width="90%" height={16} />
                  <Skeleton variant="text" width="70%" height={16} />
                </Stack>
                {/* Button skeleton */}
                <Skeleton
                  variant="rounded"
                  width={66}
                  height={46}
                  sx={{ flexShrink: 0 }}
                />
              </Stack>
            </Box>
          ))}
        </Box>
      </Stack>
    </Box>
  );
};
